'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = getSize;

var _sizes = require('../constants/sizes');

function getSize(size) {
	if (size === undefined || size === '') {
		return 0;
	}

	switch (size) {
		case _sizes.Sizes.xxs:
			return 5;
		case _sizes.Sizes.xs:
			return 10;
		case _sizes.Sizes.sm:
			return 20;
		case _sizes.Sizes.md:
			return 30;
		case _sizes.Sizes.lg:
			return 40;
		case _sizes.Sizes.xl:
			return 50;
		case _sizes.Sizes.xxl:
			return 80;
		case _sizes.Sizes.xxxl:
			return 120;
		case _sizes.Sizes.none:
			return 0;
	}
}